import { Outlet } from 'react-router-dom'
import { useRouter } from '~/hooks/useRouter'
import { Menu } from '~/components/Menu/Menu'
import { Footer } from '~/components/Footer/Footer'
import { FloatingMessenger } from '~/components/FloatingMessenger/FloatingMessenger'

export default function Layout() {
  const { asPath } = useRouter()

  const isMainPage =
    asPath === '/' ||
    asPath === '/ro' ||
    asPath === '/ru' ||
    asPath.startsWith('/?') ||
    asPath.startsWith('/ro?') ||
    asPath.startsWith('/ru?')

  return (
    <>
      <meta
        name="keywords"
        content="Dulap Studio, dulap personalizat Chișinău, mobilier la comandă Moldova, dulap la comandă, mobilă la comandă Chișinău, мебель на заказ Кишинев, тумбочка кишинев, тумба, комод кишинев, тумба молдова, комод Молдова, мебель на заказ Молдова"
      />

      <div className="layout">
        <Menu />
        <main className={`main ${isMainPage ? '' : 'mainOffset'}`}>
          <Outlet />
        </main>
        <Footer />
        <FloatingMessenger />
      </div>
    </>
  )
}